import { EventConstants, MapConstants } from "../_constants";

const initialState = {
  loading: false,
  // eventTypes: [],
  items: [],
};
export function event(state = initialState, action) {
  switch (action.type) {
    // case EventConstants.FETCH_EVENT_TYPES_REQUEST:
    //   return {
    //     ...state,
    //     eventTypes: {
    //       loading: true,
    //       error: undefined,
    //     },
    //   };

    // case EventConstants.FETCH_EVENT_TYPES_SUCCESS:
    //   return {
    //     ...state,
    //     eventTypes: {
    //       loading: false,
    //       items: action.payload,
    //       error: undefined,
    //     },
    //   };

    // case EventConstants.FETCH_EVENT_TYPES_FAILURE:
    //   return {
    //     ...state,
    //     eventTypes: {
    //       loading: false,
    //       items: [],
    //       error: action.error,
    //     },
    //   };

    case EventConstants.SAVE_NEW_EVENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: undefined,
      };
    case EventConstants.SAVE_NEW_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        items: [...state.items, action.payload],
      };

    case EventConstants.SAVE_NEW_EVENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case EventConstants.GET_CHRONICLE_EVENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: undefined,
        params: action.params,
      };

    case EventConstants.GET_CHRONICLE_EVENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        params: undefined,
        items: action.payload,
      };

    case EventConstants.GET_CHRONICLE_EVENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case EventConstants.DELETE_EVENT_REQUEST:
      return {
        ...state,
        loading: true,
        params: action.params,
        error: undefined,
      };

    case EventConstants.DELETE_EVENT_SUCCESS: {
      const { payload } = action;
      const oldItemIndex = state.items.findIndex((e) => e._id === payload);
      const newItems = [
        ...state.items.slice(0, oldItemIndex),
        ...state.items.slice(oldItemIndex + 1),
      ];
      return {
        ...state,
        loading: false,
        params: undefined,
        error: undefined,
        items: newItems,
      };
    }

    case EventConstants.DELETE_EVENT_FAILURE: {
      const { error } = action;
      return {
        ...state,
        loading: false,
        params: undefined,
        error,
      };
    }

    case EventConstants.UPDATE_EVENT_REQUEST: {
      const { params } = action;
      return {
        ...state,
        params,
        error: undefined,
        loading: true,
      };
    }

    case EventConstants.UPDATE_EVENT_SUCCESS: {
      const { payload } = action;
      const oldItemIndex = state.items.findIndex((e) => e._id === payload._id);
      const newItems = [
        ...state.items.slice(0, oldItemIndex),
        payload,
        ...state.items.slice(oldItemIndex + 1),
      ];
      return {
        ...state,
        loading: false,
        params: undefined,
        error: undefined,
        items: newItems,
      };
    }

    case EventConstants.UPDATE_EVENT_FAILURE: {
      const { error } = action;
      return {
        ...state,
        loading: false,
        params: undefined,
        error,
      };
    }

    case EventConstants.DELETE_MULTIPLE_EVENT_REQUEST: {
      const { params } = action;
      return {
        ...state,
        loading: true,
        error: undefined,
        params,
      };
    }

    case EventConstants.DELETE_MULTIPLE_EVENT_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        loading: false,
        params: undefined,
        error: undefined,
        items: [...payload],
      };
    }

    case EventConstants.DELETE_MULTIPLE_EVENT_FAILURE: {
      const { error } = action;
      return {
        ...state,
        loading: false,
        params: undefined,
        error,
      };
    }

    case EventConstants.MOVE_EVENT_REQUEST: {
      const { params } = action;
      return {
        ...state,
        loading: true,
        error: undefined,
        params,
      };
    }

    case EventConstants.MOVE_EVENT_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        loading: false,
        error: undefined,
        params: undefined,
        items: [...payload],
      };
    }

    case EventConstants.MOVE_EVENT_FAILURE: {
      const { error } = action;
      return {
        ...state,
        loading: false,
        error,
        params: undefined,
      };
    }

    case MapConstants.REFRESH_EVENTS_AND_MARKERS: {
      const { payload } = action;
      let newItems;
      if (payload.events) {
        newItems = state.items.map((i) => {
          const idx = payload.events.findIndex((e) => e._id === i._id);

          return idx < 0 ? i : payload.events[idx];
        });
      } else {
        newItems = state.items;
      }
      return {
        ...state,
        items: [...newItems],
      };
    }

    default:
      return state;
  }
}
